<template>
  <span class="icon is-small is-right" @click.prevent="show = !show">
    <div class="dropdown is-right is-up is-active">
      <div class="dropdown-trigger">
        <font-awesome-icon :icon="icons.down" />
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu" v-if="show">
        <div class="dropdown-content">
          <div class="dropdown-item" v-for="(page, idx) in pages" :key="idx" @click.prevent="handleClick(idx)">
            {{ page.ID }}
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'pageSelect',
  props: ['label', 'value'],
  data () {
    return {
      // content: this.value,
      icons: {
        down: faChevronDown
      },
      show: false
    }
  },
  computed: {
    pages () {
      var self = this
      return self.$store.state.sitemap.filter((item) => {
        return item.ID !== self.$store.state.activePage.ID
      })
    }
  },
  methods: {
    handleClick: function (idx) {
      var self = this
      // self.show = !self.show
      // var idx = e.target.getAttribute('value')
      var value = '/' + self.$store.state.language + '/' + self.pages[idx].ID
      // self.content = value
      self.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>

.icon{
  z-index: 1;
  cursor: pointer;
  pointer-events: all !important;

  .dropdown{
    .dropdown-content{
      max-height: 250px;
      overflow: auto;
      .dropdown-item{
        &:hover{
          background-color: $grey-bg;
        }
      }
    }
  }
}
</style>
